import { BaseError } from './BaseError'

const DateErrorId = ['INVALID_DATE'] as const

type DateErrorType = (typeof DateErrorId)[number]

const messages = {
    INVALID_DATE: 'String cannot be parsed into date',
}

export class DateError extends BaseError {
    constructor(public readonly type: DateErrorType) {
        super({
            cause: new Error(messages[type]) || new Error('DATE_ERROR'),
        })
    }
}
